<template>
	<div class="main_section meal-management-page p-3">

		<div v-if="$route.name === 'meal_management2'">
			<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
				<span class="cursor-pointer flex i18n-locale"><img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2"></span></span>
				<vs-dropdown-menu class="w-50 i18n-dropdown">
					<vs-dropdown-item @click="updateLocale('en')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('pt')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('br')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('de')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('fr')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('es')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

        <div class="mb-4"> 
			<h1 :class="(($route.name === 'meal_management2')) ? 'my-5' : ''">{{$t('meal_management')}} v2</h1>
			<h4 class="mt-2">{{user.hotel.hotel_name}}</h4>
		</div>

		<vx-card class="stats-card">
			<div class="lg:w-1/2 w-full">
				<div class="vx-row">
					<div class="vx-col md:w-1/2 lg:w-2/4 w-full">
						<small class="block">{{$t('space')}}</small>
						<v-select class="w-full"
							:searchable="false"
							v-model="space_selected"
							:options="space_list"
							label="space_name"
							placeholder="---">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
						</v-select>
					</div>
					<div class="vx-col md:w-1/2 lg:w-2/4 w-full">
						<small class="block">{{$t('service_type')}}</small>
						<v-select class="w-full"
							:searchable="false"
							v-model="service_type_selected"
							:options="service_type_list"
							:label="'name_'+$i18n.locale"
							placeholder="---">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
                		</v-select>
					</div>
				</div>
			</div>
		</vx-card>

		<div class="vx-row mt-8 mb-4" v-if="show_stats">
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-purple">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ previsao_total }}</b></h3>
						<div class="text-sm">{{ $t('forecast') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-yellow">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ marcacoes }}</b></h3>
						<div class="text-sm">{{ $t('appointments') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-green">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ presencas }}</b></h3>
						<div class="text-sm">{{ $t('presencas') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-red">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ faltas() }}</b></h3>
						<div class="text-sm">{{ $t('Faltas') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
		</div>

		<vx-card class="mt-8 mb-8" v-show="show_table">
			<div>
				<vs-table class="bookings-table stripe mt-2" search pagination max-items="20" :data="bookings" :noDataText="$t('bookings_no_items')" ref="tabela">
					<template slot="thead">
						<vs-th sort-key="rsv_number">
							{{$t('rsv_number')}}
						</vs-th>
						<vs-th sort-key="nome">
							{{$t('nome')}}
						</vs-th>
						<vs-th sort-key="room_number">
							{{$t('room_number')}}
						</vs-th>
						<vs-th sort-key="regime">
							{{$t('regime')}}
						</vs-th>
						<vs-th sort-key="adultos">
							{{$t('adultos')}}
						</vs-th>
						<vs-th sort-key="criancas">
							{{$t('criancas')}}
						</vs-th>
						<vs-th sort-key="bebes">
							{{$t('bebes')}}
						</vs-th>
						<vs-th sort-key="service_type" v-if="show_table">
							{{service_type_selected['name_'+$i18n.locale]}}
						</vs-th>
						<vs-th sort-key="check_in">
							Check In
						</vs-th>
						<vs-th sort-key="check_out">
							Check Out
						</vs-th>
						<vs-th sort-key="service">
							{{$t('service')}}
						</vs-th>
						<vs-th sort-key="horario">
							{{$t('horario')}}
						</vs-th>
						<vs-th sort-key="n_grupo">
							{{$t('n_grupo')}}
						</vs-th>
						<vs-th sort-key="people_n">
							{{$t('people_n')}}
						</vs-th>
						<vs-th sort-key="n_presencas">
							{{$t('n_presencas')}}
						</vs-th>
					</template>	

					<template slot-scope="{data}">
						<vs-tr 
							:key="idx" 
							v-for="(item, idx) in data" 
							:state="item.presencas > 0 ? 'success' : item.n_grupo != '---' ? 'warning' : null" 
							class="cursor-pointer" 
							v-on:click.native="handleSelected(item)"
							v-if="show_table">
							
							<vs-td>
								{{item.reserva}}
							</vs-td>
							<vs-td>
								{{item.nome}}
							</vs-td>
							<vs-td>
								{{item.n_quarto}}
							</vs-td>
							<vs-td>
								{{item.regime}}
							</vs-td>
							<vs-td>
								{{item.adultos}}
							</vs-td>
							<vs-td>
								{{item.criancas}}
							</vs-td>
							<vs-td>
								{{item.bebes}}
							</vs-td>
							<vs-td>
								{{ item.pequeno_almoco || item.almoco || item.jantar }}
							</vs-td>
							<vs-td>
								{{item.check_in}}
							</vs-td>
							<vs-td>
								{{item.check_out}}
							</vs-td>
							<vs-td>
								{{item.servico}}
							</vs-td>
							<vs-td>
								{{item.horario}}
							</vs-td>
							<vs-td>
								{{ item.n_grupo == null ? '---' : item.n_grupo }}
							</vs-td>
							<vs-td>
								{{item.pessoas}}
							</vs-td>
							<vs-td>
								{{item.presencas}}
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
				<div class="mt-6">
					<h5>{{ $t('nova_marcacao') }}</h5>
				</div>
				<div class="block lg:w-1/4 sm:w-1/2 w-full mt-5">
					<small class="block">{{$t('nome')}}</small>
					<vs-input class="w-full" placeholder="" v-model="passante_name" @focus="keyboard_show" data-layout="normal"/>
				</div>
				<div class="flex items-end mt-5">
					<div class="flex flex-col mr-2">
						<small class="mb-1 ml-1">{{$t('presencas')}}</small>
						<vs-input-number 
							class="w-24 m-0 ml-4" 
							min="0" 
							v-model="passante_presencas" 
							@focus="keyboard_show"
						/>
					</div>
					
					<vs-button 
						color="primary" 
						class="m-0 ml-5"
						@click="save_presencas('marcar_passante')"
					>
						{{$t('register')}}
					</vs-button>
					</div>


			</div>
		</vx-card>

		<vs-popup :title="item_selected_title" :active.sync="show_pop_up_row">
			<div>
				<div class="vs-con-table stripe vs-table-primary">
					<div class="con-tablex vs-table--content">
						<div class="vs-con-tbody vs-table--tbody " style="max-height:auto;">
							<table class="vs-table vs-table--tbody-table">
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('tipo_de_marcacao')}}</td></b>
									<td class="td vs-table--td">{{item_selected.rsv_type}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('tipo_de_espaco')}}</td></b>
									<td class="td vs-table--td">{{item_selected.space_type_name}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('data_do_registo')}}</td></b>
									<td class="td vs-table--td">{{item_selected.created_date}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('mesas')}}</td></b>
									<td class="td vs-table--td">{{item_selected.ocupacao_mesa_str}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('n_quarto')}}</td></b>
									<td class="td vs-table--td">{{item_selected.room_number}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('grupo')}}</td></b>
									<td class="td vs-table--td">{{item_selected.n_grupo}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('n_presenças')}}</td></b>
									<td class="td vs-table--td">
										<div class="text-left">
											<vs-input-number class="w-1/4" min="0" v-model.number="item_selected.num_people_show" name="presencas" step="1"/>
										</div>
									</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('registado_por')}}</td></b>
									<td class="td vs-table--td">{{item_selected.created_by}}</td>
								</tr>
								<tr class="tr-values vs-table--tr tr-table-state-null">
									<b><td class="td vs-table--td">{{$t('observacoes')}}</td></b>
									<td class="td vs-table--td">{{item_selected.observations}}</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="text-right mt-4">
				<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="success" type="filled" v-on:click="save_presencas()">{{$t('Gravar')}}</vs-button>
				<vs-button class="sm:w-full md:w-1/3 lg:w-1/4 m-1" color="danger" type="filled" v-on:click="show_pop_up_row=false">{{$t('sair')}}</vs-button>
			</div>
		</vs-popup>

		<vue-touch-keyboard class="v-touch-keyboard" :options="keyboard.options" v-if="keyboard.visible && $route.params.pos == 1 && !isMobile()" :layout="keyboard.layout" :cancel="keyboard_hide" :accept="keyboard_accept" :input="keyboard.input" />

	</div>
</template>

<script>
import { XCircleIcon } from 'vue-feather-icons';
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/dist/locale';
import moment, { lang } from 'moment';

import VueTouchKeyboard from "vue-touch-keyboard";
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style


export default {
	components: {
		XCircleIcon,
		Datepicker,
		vueTouchKeyboard: VueTouchKeyboard.component
	},
	data(){
		return {
			user: JSON.parse(localStorage.getItem('userSession')),
			space_list: [],
			service_type_list: [],
			space_selected: null,
			service_type_selected: null,
			previsao_total: 0,
			marcacoes: 0,
			presencas: 0,
			bookings: [],
			show_stats: false,
			show_table: false,
			item_selected: [],
			item_selected_title: '',
			passante_name: '',
			passante_presencas: 0,
	    	keyboard: {
				visible: false,
		      	layout: "normal",
		      	input: null,
		      	options: {
			        useKbEvents: false
			    }
		  	},
			show_pop_up_row: false,
		}
	},
	methods: {
		get_spaces_and_services(){
			this.$vs.loading();
			let that = this;
			
			this.$api({
				method: 'get',
				url: '/myvilagale/appointments/get_spaces',
				params: {
					token: this.user.usertoken,
					cod_hotel: this.user.hotel.hotel_id,
					active: 1,
					space_type_id: 1, // 1 = restaurante
				},
			}).then(function (res) {

				that.space_list = res.data.data;
				if(that.space_list.length > 0){
					that.user.hotel.hotel_name = that.space_list[0].hvg_desc;
				}

				that.$api({
					method: 'get',
					url: '/myvilagale/appointments/get_service_type',
					params: {
						token: that.user.usertoken,
					},
				}).then(function (res) {
					that.service_type_list = res.data;
				}).catch( function (err) {
					that.notify('ERRO 1.0', 'red');
				}).then(function() {
					that.$vs.loading.close();
				});

			}).catch( function (err) {
    			that.notify('ERRO 1.1', 'red');
			}).then(function() {
    			that.$vs.loading.close();
			});
		},
		get_stats(apenas_stats = 0){
			this.$vs.loading();
			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/appointments/get_stats',
				params: {
					token: this.user.usertoken,
					hotel_id: this.user.hotel.hotel_id,
					space_hotel_id: this.space_selected.space_hotel_id,
					service_type_id: this.service_type_selected.service_type_id
				},
			}).then(function (res) {
				that.marcacoes = res.data[0]['marcacoes'];
				that.presencas = res.data[0]['presencas'];
				that.previsao_total = res.data[0]['previsao_total'];
				that.show_stats = true;
				if(apenas_stats == 0){
					that.get_bookings()
				}
			}).catch( function (err) {
				that.show_stats = false;
    			that.notify('ERRO 2.0', 'red');
				that.$vs.loading.close();
			}).then(function() {
				// if(!only_presencas){
				// 	that.$vs.loading.close();
				// }
			});
		},
		get_bookings(loading = false){
			if(loading){
				this.$vs.loading();
			}
			let that = this;
			const today = (() => new Date().toLocaleDateString('pt-PT').replace(/\//g, '-'))();
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/get_bookings',
				params: {
					token: this.user.usertoken,
					hotel_id: this.user.hotel.hotel_id,
					service_type_id: this.service_type_selected.service_type_id,
					space_hotel_id: this.space_selected.space_hotel_id,
					date: today
				},
			}).then(function (res) {
				that.bookings = res.data;
				that.show_table = true;
			}).catch( function (err) {
    			that.notify('ERRO 2.1', 'red');
			}).then(function() {
				that.$vs.loading.close();
			});
		},
		handleSelected(item) {
			this.$vs.loading();
			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/find_booking',
				params: {
					token: this.user.usertoken,
					num_reserva: item.reserva,
					lang: this.$i18n.locale,
					hotel_id: this.user.hotel.hotel_id,
					space_hotel_id: this.space_selected.space_hotel_id,
					service_type_id: this.service_type_selected.service_type_id,
					reservation_id: item.reservation_id
				},
			}).then(function (res) {
				that.item_selected = res.data[0];
				that.item_selected.num_people_show = Number(that.item_selected.num_people_show || 0);
				that.item_selected.num_people_show_original = Number(that.item_selected.num_people_show_original || 0);
				if(isNaN(parseInt(item.adultos)) || isNaN(parseInt(item.criancas)) || isNaN(parseInt(item.bebes))){
					that.item_selected.total_pessoas = parseInt(item.total_pessoas);
				}else{
					that.item_selected.total_pessoas = parseInt(item.adultos) + parseInt(item.criancas) + parseInt(item.bebes);
				}
				that.item_selected.reserva = item.reserva;
				that.item_selected.nome = item.nome;
				that.item_selected.n_quarto = item.n_quarto;
				that.item_selected.space_type_name = item.space_type_name == null ? that.space_selected.type_space : item.space_type_name;
				that.show_pop_up_row = true;
			}).catch( function (err) {
    			that.notify('ERRO 3', 'red');
			}).then(function() {
				that.$vs.loading.close();
			});
		},
		faltas() {
    		return Math.max(0, this.previsao_total - this.presencas);
    	},
		// send_people_show() {
		// 	this.show_pop_up_row = false;
		// 	if(this.item_selected.num_people_show == this.item_selected.num_people_show_original) {
		// 		return;
		// 	}
		// 	let that = this;
		// 	this.$api({
		// 		method: 'post',
		// 		url: '/myvilagale/bookings/update_num_people_show',
		// 		params: {
		// 			token: this.user.usertoken,
		// 			reservation_distribution_id: this.item_selected.reservation_distribution_id,
		// 			num_people_show: this.item_selected.num_people_show
		// 		},
		// 	}).then(function (res) {
		// 		that.get_bookings(true);
		// 		that.notify(this.$t('n_presencas_registado'), 'green');
		// 	}).catch( function (err) {
		// 		that.item_selected.num_people_show = that.item_selected.num_people_show_original;
		// 		if(err.response.data.message == 'responses.error_reservation_distribution_id'){
		// 			that.notify(this.$t('erro_numero_distribuicao_reserva'), 'red');
		// 		}else if(err.response.data.message == 'responses.error_num_people_show'){
		// 			that.notify(this.$t('erro_numero_pessoas'), 'red');
		// 		}else{
		// 			that.notify(this.$t('erro_guardar_n_presencas'), 'red');
		// 		}
		// 		that.$vs.loading.close();
		// 	}).then(function() {
		// 	});
		// },
		save_presencas(tipo = null) {
			if(!this.space_selected.space_hotel_id || !this.service_type_selected.service_type_id){
				this.notify(this.$t('select_space_service_type'), 'red');
				return;
			}
			if(tipo == 'marcar_passante' && this.passante_name.trim() == ''){
				this.notify(this.$t('fill_passante_name'), 'red');
				return;
			}
			if(tipo == 'marcar_passante' && this.passante_presencas <= 0){
				this.notify(this.$t('error_n_presencas'), 'red');
				return;
			}
			let that = this;
			this.$vs.loading();
			this.$api({
				method: 'post',
				url: '/myvilagale/appointments/meals/presencas/save',
				data: {
					token: this.user.usertoken,
					num_reserva: tipo == 'marcar_passante' ? null : this.item_selected.reserva,
					room_number: tipo == 'marcar_passante' ? null : this.item_selected.n_quarto,
					hotel_id: this.$route.params.hotelId,
					space_hotel_id: this.space_selected.space_hotel_id,
					service_type_id: this.service_type_selected.service_type_id,
					n_people: tipo == 'marcar_passante' ? this.passante_presencas : this.item_selected.total_pessoas,
					n_presencas: tipo == 'marcar_passante' ? this.passante_presencas : this.item_selected.num_people_show,
					reservation_distribution_id: tipo == 'marcar_passante' ? null : this.item_selected.reservation_distribution_id,
					passante_name: tipo == 'marcar_passante' ? this.passante_name : null
				}
			}).then(function (res) {
				that.show_pop_up_row = false;
				that.notify(that.$t('save_presencas_sucesso'), 'green');
				if(tipo == 'marcar_passante'){
					that.passante_name = '';
					that.passante_presencas = 0;
				}
				that.get_stats(1);
				that.get_bookings(true);
			}).catch(function (err) {
				if(err.response.data.message){
					if(err.response.data.message == 'schedule_not_found'){
						that.notify(that.$t('schedule_not_found'), 'red');
					}else if(err.response.data.message == 'invalid_presencas_value'){
						that.notify(that.$t('invalid_presencas_value'), 'red');
					}else{
    					that.notify(err.response.data.message, 'red');
					}
				}else{
					that.notify('ERRO 4', 'red');
				}
				that.$vs.loading.close();
			}).then(function () {
			});
		},
		keyboard_accept(text) {
          //alert("Input text: " + text);
          this.keyboard_hide();
        },
        keyboard_show(e) {
          this.keyboard.input = e.target;
          this.keyboard.layout = e.target.dataset.layout;
 
          if (!this.keyboard.visible)
            this.keyboard.visible = true
        },
        keyboard_hide() {
          this.keyboard.visible = false;
        }
	},
	computed: {
	},
	watch: {
		space_selected: function(new_val, old_val) {
			if(new_val != null && this.service_type_selected != null){
				this.get_stats();
			}
			if(new_val == null){
				this.show_stats = false;
				this.show_table = false;
			}
		},
		service_type_selected: function(new_val, old_val) {
			if(new_val != null && this.space_selected != null){
				this.get_stats();
			}
			if(new_val == null){
				this.show_stats = false;
				this.show_table = false;
			}
		},
		'$i18n.locale': function(new_value, old_val) {
			this.get_bookings(true);
		},
		show_pop_up_row: function(new_val, old_val) {
			if(new_val == false){
				this.item_selected_title = '';
				this.item_selected = [];
			}else{
				this.item_selected_title = this.item_selected.reserva+ ' | ' +this.item_selected.nome+ ' | ' +this.item_selected.total_pessoas+ ' '+this.$t('Pessoas');
			}
		},
	},
	mounted() {
		let el = document.querySelector(".bookings-table .vs-table--search-input");
		let that = this;
		if(el.onfocus === null) {
			el.dataset.layout = "normal";
			el.onfocus = function(e) {
				that.keyboard_show(e);
			};
			/*el.onblur = function(e) {
				that.keyboard_hide(e);
			};*/
		}
	},
	created() {
		this.user = {
			usertoken: this.$route.params.token,
			hotel: {
				hotel_id: this.$route.params.hotelId,
				hotel_name: null,
			}
		};
		
		this.get_spaces_and_services();
	},
}
</script>

<style scoped>
	.table_schedule_wrapper {
		position: relative;
		z-index: 0;
	}
	.table_schedule_wrapper .vs-input-number, .table_dish_wrapper .vs-input-number {
		background-color: transparent;
	}
	.datePickerDiv >>> input {
	  border: none;
	  background: transparent;
	  color: transparent;
	  width: 0;
	  height: 0;
	}
	.datePickerDiv >>> .vdp-datepicker {
	  right: 96px;
	  width: 0;
	  height: 0;
	}
	.datePickerDiv >>> .vdp-datepicker__calendar {
		top: 0;
		z-index: 999;
		height: 282px;
	}
	.datePickerDiv >>> .vdp-datepicker__calendar > div {
		background-color: #ffffff;
	}
	.stats-card >>> .vs-dropdown-menu {
		width: 130px;
	}
	.stats-card .vue-select {
		min-width: 240px;
	}
	.icon-calendar:before {
	    content: "";
	}
	.logo-text{
        font-size: 26px;
        font-weight: 600;
        color: #4A4E4F;
        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
		font-family: 'Titillium Web',sans-serif;
      }
      @media screen and (max-width: 767.98px) {
      	.meal-management-page  >>>.vx-card__actions {
      		width: 100%;
      		text-align: right;
      	}
      	.stats-card .vue-select, .icon-calendar {
			margin-top: 10px;
		}
		.datePickerDiv >>> .vdp-datepicker {
			right: 10px;
		}
      }
      @media screen and (max-width: 450px) {
      	.datePickerDiv >>> .vdp-datepicker {
			right: -50px;
		}
      }
      @media screen and (max-width: 376px) {
      	.datePickerDiv >>> .vdp-datepicker {
			right: -10px;
		}
      }
	  
	.bookings-table >>> .con-pagination-table .vs-pagination--mb {
		width: 100% !important;
		padding: 0 !important;
	}
	.v-touch-keyboard {
    	z-index: 99999;
    	background-color: #ffffff;
    	position: fixed;
    	width: 70%;
    	left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto auto;
	    padding: 1em;
	    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.3);
	    border-radius: 10px;
    }
    .v-touch-keyboard >>> .keyboard .key {
    	font-size: 1.45em;
    }
    @media screen and (max-width: 992px) {
		.v-touch-keyboard {
	    	width: 100%;
		}
	}
	.icon-wrapper {
		width: 48px;
		height: 48px;
		
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.icon-wrapper svg {
		width: 24px;
		height: 24px;
	}
	.iw-purple {
		background-color: #d3bffe; /* Roxo */
	}
	.iw-yellow {
		background-color: #e8fd8e; /* Amarelo */
	}
	.iw-green {
		background-color: #9fffa6; /* Verde */
	}
	.iw-red {
		background-color: #fca1a1; /* Vermelho */
	}

</style>
<style>
    .filter_date .vdp-datepicker__calendar{
    	bottom: inherit;
    }
	.vs-input-number .btn-plus {
		width: 35px;
		height: 35px;
		font-size: 20px;
	}
	.vs-input-number .btn-less {
		width: 35px;
		height: 35px;
		font-size: 20px;
	}
	.vs-input-number input {
		height: 35px; /* ajusta a altura do campo para combinar */
		font-size: 16px;
	}
    
</style>